import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Session-expiry guard + v403.0 gateway-hiccup retry:
// - Retry GETs ONCE (1.5s backoff) when the response is missing entirely
//   (network / unparseable origin) or a gateway error (502/503/504/52x) —
//   brief production restarts no longer surface Cloudflare banners.
// - Any 401 outside the auth endpoints means the cookie died while the page
//   was open (12h sessions). Hard-redirect to /login with a flag so the login
//   page can explain, instead of surfacing raw "Not authenticated" toasts.
const GATEWAY_ERRORS = [502, 503, 504, 520, 521, 522, 523, 524];

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const cfg = err?.config || {};
    const status = err?.response?.status;
    const retriable = !err?.response || GATEWAY_ERRORS.includes(status);
    if (retriable && (cfg.method || "get").toLowerCase() === "get" && !cfg._retried) {
      cfg._retried = true;
      await new Promise((r) => setTimeout(r, 1500));
      return api.request(cfg);
    }
    const url = cfg.url || "";
    const path = window.location.pathname;
    const onAuthPage = path.startsWith("/login") || path.startsWith("/register");
    if (status === 401 && !url.includes("/auth/") && !onAuthPage) {
      window.location.assign("/login?expired=1");
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fileUrl(path) {
  if (!path) return null;
  // v414.67 — absolute paths (static /products/* assets or full URLs) pass through
  if (path.startsWith("/") || path.startsWith("http")) return path;
  return `${API}/files/${path}`;
}
